import React from "react";
import { Tooltip, TooltipProps, styled, tooltipClasses } from "@mui/material";
import { AppTheme } from "../../utils/theme";

export const CustomTooltip = styled(({ className, ...props }: TooltipProps) => (
	<Tooltip {...props} classes={{ popper: className }} />
))(({ theme }: { theme: AppTheme }) => ({
	[`& .${tooltipClasses.tooltip}`]: {
		backgroundColor: theme.palette.surface.dark,
		color: theme.palette.text.primary,
	},
}));

export default CustomTooltip;
